const resultComps = {}
let requireComponent = require.context(
    './', // �ڵ�ǰĿ¼�²���
    false, // ���������ļ���
    /\.vue$/ // ����ƥ�� �� .vue��β���ļ�
)
requireComponent.keys().forEach(fileName => {
    let comp = requireComponent(fileName)
    resultComps[fileName.replace(/^\.\/(.*)\.\w+$/, '$1')] = comp.default
})
export default resultComps